import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import BaseURL from "../BaseURL/BaseURL";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const FilterModal = (props) => {
  const [zipcode, setZipcode] = useState(null);
  const [PostalCode, setPostalCode] = useState();
  const [Step, setStep] = useState(0);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        geolocationSuccess,
        geolocationError
      );
    }
  };

  const geolocationSuccess = (position) => {
    const { latitude, longitude } = position.coords;
    console.log(position, "zipcode");
    // Use the Google Maps Geocoding Service to get ZIP code
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latitude, longitude);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        let found = false;
        for (let result of results) {
          for (let component of result?.address_components) {
            if (component.types.includes("postal_code")) {
              setZipcode(component.short_name);
              found = true;
              break;
            }
          }
          if (found) break;
        }

        if (!found) {
          setZipcode("ZIP code not found");
        }
      } else {
        console.error("Error fetching ZIP code:", status);
        setZipcode("Error fetching ZIP code");
      }
    });
  };

  const geolocationError = (error) => {
    console.error("Error getting user location:", error);
  };

  const navigate = useNavigate();
  const [category, setCategory] = useState("");
  const [subcategory, setSubCategory] = useState("");
  const [, setLoader] = useState(false);

  const getCategory = (name) => {
    setCategory(name);
    if (
      name === "Crowns, Inlays and Onlays" ||
      name === "Diagnostic Services" ||
      name === "Prosthetic Services" ||
      name === "Root Canal" ||
      name === "Surgery" ||
      name === "X-Rays"
    ) {
      setStep(2);
    } else {
      search(name);
    }
  };
  const getSubCategory = (subname) => {
    // Update the state with the new object
    setSubCategory(subname);
    search(category, subname);
  };

  const search = (Category, subCate) => {
    setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/doctor?zip_code=${
          PostalCode ? PostalCode : zipcode
        }&category=${Category ? Category : category}&subCategory=${subCate}`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          if (response?.data?.status === true) {
            Swal.fire({
              title: "Something Went Wrong",
              text: response?.data?.message,
              icon: "success",
              dangerMode: true,
            });
            // setSearchApi(response.data.data);
            navigate("/practitioner", { state: response.data.data });
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  console.log(subcategory, "zipcode");
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Find Best Dentist For You
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Step === 0 ? (
            <>
              {/* <h4 className="text-center">What type of care do you need?</h4> */}
              <input
                type="text"
                value={zipcode}
                placeholder="Zip Code or City, State (e.g, 12345 or New York, NY)"
                onChange={(e) => setPostalCode(e.target.value)}
                className="form-control"
              />
              <span>
                <p
                  className="text-center mt-3 getlocation"
                  onClick={getCurrentLocation}
                >
                  Use Current location
                </p>
              </span>
            </>
          ) : Step === 1 ? (
            <>
              <h4 className="text-center">What type of care do you need?</h4>
              <div className="row justify-content-center mt-5">
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Anesthesia - General")}
                >
                  Anesthesia - General
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Fillings")}
                >
                  Fillings
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Periodontal Services")}
                >
                  Periodontal Services
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Crowns, Inlays and Onlays")}
                >
                  Crowns, Inlays and Onlays
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Medications")}
                >
                  Medications
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Preventative")}
                >
                  Preventative
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Diagnostic Services")}
                >
                  Diagnostic Services
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Tooth Extraction")}
                >
                  Tooth Extraction
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Prosthetic Services")}
                >
                  Prosthetic Services
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Root Canal")}
                >
                  Root Canal
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("X-Rays")}
                >
                  X-Rays
                </button>
                <button
                  className="btn btn-primary col-md-5 m-1"
                  onClick={() => getCategory("Surgery")}
                >
                  Surgery
                </button>
                <button
                  className="btn btn-primary col-md-10 m-1"
                  onClick={() =>
                    getCategory("Other Common Services, Materials")
                  }
                >
                  Other Common Services, Materials
                </button>
              </div>
            </>
          ) : Step === 2 ? (
            <>
              <h4 className="text-center">What type of care do you need?</h4>
              {category === "Crowns, Inlays and Onlays" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() =>
                      getSubCategory("Crowns Used to Replace Missing Teeth")
                    }
                  >
                    Crowns Used to Replace Missing Teeth
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() =>
                      getSubCategory("Crowns Used to Replace Tooth Structure")
                    }
                  >
                    Crowns Used to Replace Tooth Structure
                  </button>

                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Inlays and Onlays")}
                  >
                    Inlays and Onlays
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Veneers")}
                  >
                    Veneers
                  </button>
                </div>
              ) : null}
              {category === "Diagnostic Services" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Exams")}
                  >
                    Exams
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Risk")}
                  >
                    Risk
                  </button>

                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Tests")}
                  >
                    Tests
                  </button>
                </div>
              ) : null}
              {category === "Prosthetic Services" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Bridges & Implants")}
                  >
                    Bridges & Implants
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Denture, Complete")}
                  >
                    Denture, Complete
                  </button>

                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Denture, Partial")}
                  >
                    Denture, Partial
                  </button>
                </div>
              ) : null}
              {category === "Root Canal" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() =>
                      getSubCategory("Apexification, Pulp regeneration")
                    }
                  >
                    Apexification, Pulp regeneration
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("root canal therapy")}
                  >
                    root canal therapy
                  </button>
                </div>
              ) : null}
              {category === "Surgery" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Bone Surgery")}
                  >
                    Bone Surgery
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() =>
                      getSubCategory("Grafts (Bone and Soft Tissue)")
                    }
                  >
                    Grafts (Bone and Soft Tissue)
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("Soft Tissue (Gum)")}
                  >
                    Soft Tissue (Gum)
                  </button>
                </div>
              ) : null}
              {category === "X-Rays" ? (
                <div className="row justify-content-center mt-5">
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("X-ray - complex")}
                  >
                    X-ray - complex
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("X-Ray - Jaws")}
                  >
                    X-Ray - Jaws
                  </button>
                  <button
                    className="btn btn-primary col-md-5 m-1"
                    onClick={() => getSubCategory("X-Ray - Teeth")}
                  >
                    X-Ray - Teeth
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <div className="">
            <Button onClick={props.onHide}>Close</Button>
          </div>
          <div>
            {Step === 0 ? (
              <Button onClick={() => setStep(1)}>Next</Button>
            ) : Step === 1 ? (
              <>
                <Button onClick={() => setStep(0)} className="me-3">
                  previous
                </Button>
                <Button onClick={() => setStep(2)}>Next</Button>
              </>
            ) : null}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FilterModal;
